export default "/images/brand2.png?691197c3aecaab15201b60658af33ba7";